import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbSecurityModule } from '@nebular/security';
import { MaterialModule } from '../../shared/material-module';
import { IndustriesRoutingModule } from './industries-routing.module';
import { IndustriesComponent } from './industries.component';
import { IndustryEditDialogComponent } from './industry-edit/industry-edit-dialog.component';
import { IndustryEditPageComponent } from './industry-edit/industry-edit-page.component';
import { IndustryEditComponent } from './industry-edit/industry-edit.component';

export { IndustriesComponent };

@NgModule({
  declarations: [
    IndustriesComponent,
    IndustryEditComponent,
    IndustryEditDialogComponent,
    IndustryEditPageComponent
  ],
  imports: [
    CommonModule,
    IndustriesRoutingModule,
    MaterialModule,
    FormsModule,
    NbSecurityModule,
    ReactiveFormsModule
  ],
  exports: [IndustriesComponent]
})
export class IndustriesModule {}
